import request from '@/utils/request'
import store from '@/store'
import axios from 'axios'

const url = store.getters.getPostUrl;
export default {
  getCheckPage(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/page',
      method: 'post',
      data: param
    })
  },
	getDeleteCheckPage(param) {
	  return request({
	    url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/deletePage',
	    method: 'post',
	    data: param
	  })
	},

  getCheckStatus(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/status',
      method: 'post',
      data: param
    })
  },
  getCheckStatus2(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/status2',
      method: 'post',
      data: param
    })
  },
  getDeleteCheckStatus2(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/deleteStatus2',
      method: 'post',
      data: param
    })
  },
  getCheckResultsById(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/pageAll',
      method: 'post',
      params: param
    })
  },
    getCheckEmailById(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/pageByEmailSendId',
      method: 'post',
      data: param
    })
  },
  getCheckCount(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/selectCount',
      method: 'post',
      data: param
    })
  },
  getCheckExcel(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/excel',
      method: 'get',
      params: param
    })
  },
  checkTimeAdd(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckTime/insert',
      method: 'post',
      data: param
    })
  },
  checkTimeUpdate(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckTime/update',
      method: 'post',
      data: param
    })
  },
  checkTimeDelete(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckTime/delete',
      method: 'delete',
      params: {'id': param}
    })
  },
  timeBatchSave(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckTime/batchInsert',
      method: 'post',
      data: param
    })
  },
  selectTimeData(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckTime/page',
      method: 'post',
      data: param
    })
  },
  timeAcquiescence(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckTime/acquiescence',
      method: 'post',
      params: param
    })
  },
  checkSaveRemark(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/saveRemark',
      method: 'post',
      params: param
    })
  },
  check(data, checkUser) {//checkUser 1 班长；2 系长
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/check/' + checkUser,
      method: 'post',
      data: data
    })
  },
  checkBack(data, checkUser) {//checkUser 1 班长；2 系长
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/checkBack/' + checkUser,
      method: 'post',
      data: data
    })
  },
  notWork(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/webNotWork',
      method: 'post',
      data: param
    })
  },
  checkAllExportExcel(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/checkRecordAllExportExcel',
      method: 'post',
      data: param,
      responseType: 'blob'
    })
  },
  deleteCheckAllExportExcel(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/checkDeleteRecordAllExportExcel',
      method: 'post',
      data: param,
      responseType: 'blob'
    })
  },
  checkCountExport(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/checkCountExport',
      method: 'post',
      data: param,
      responseType: 'blob'
    })
  },
  checkResultExcel(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/checkResultExport',
      method: 'post',
      params: param,
      responseType: 'blob'
    })
  },
  checkEmailSend(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentCheckRecord/checkEmailSend',
      method: 'post',
      data: param,
      responseType: 'blob'
    })
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/spotCheck/spotCheck.js